import React from 'react';
import ReactDOM from 'react-dom';
import get from 'lodash/get';
import { Provider } from 'react-redux';
import storeBuilder from 'reduxStore/store';
import Wahanda from 'common/wahanda';
import { Initializer } from 'common/types/initializers';
import { PopoverPlacement, PopoverAnchorOffset } from 'components/common/Popover';
import { CalendarAnalytics } from 'common/analytics';
import { ShiftEmployeeModal } from './container';
import { RotaModalType } from '../utils/types';

const store = storeBuilder();
const container = Wahanda.Dialogs.getReactContainer();
interface Params {
  employeeId: number;
  employeeName: string;
  date: string;
  popoverOffset: PopoverAnchorOffset;
  popoverPlacement: PopoverPlacement;
  onAddAppointment?: () => void;
}

function destroy(target) {
  ReactDOM.unmountComponentAtNode(target);
}

const onClose = () => {
  destroy(container);
};

export const ShiftEmployeeModalInitializer = (param: Params): Initializer => ({
  destroy: () => ReactDOM.unmountComponentAtNode(container),
  render: () => {
    ReactDOM.render(
      <Provider store={store}>
        <ShiftEmployeeModal
          date={get(param, 'date')}
          employeeId={param.employeeId}
          modalType={RotaModalType.EMPLOYEE_MODAL_ACTIONS}
          onAddAppointment={param.onAddAppointment}
          onClose={onClose}
          popoverOffset={get(param, 'popoverOffset')}
          popoverPlacement={get(param, 'popoverPlacement')}
          trackingCategory={CalendarAnalytics.CATEGORY}
        />
      </Provider>,
      container,
    );
  },
});
